import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../../data/mock';

const TestimonialsSection = () => {
  return (
    <section className="py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[#000000]" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#00FFD1]/3 rounded-full blur-[200px]" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-[#00FFD1] text-sm font-medium tracking-wider uppercase">Testimonials</span>
          <h2 className="text-4xl md:text-5xl font-semibold text-white mt-4 leading-tight">
            Trusted by Distributors
            <span className="block text-white/50">Across Texas.</span>
          </h2>
        </div>
        
        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id}
              className="group bg-[#121212] border border-white/10 p-8 transition-all duration-400 hover:border-[#00FFD1]/40 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 opacity-10 group-hover:opacity-20 transition-opacity">
                <Quote className="w-12 h-12 text-[#00FFD1]" />
              </div>
              
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-[#00FFD1] fill-[#00FFD1]" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-white/80 text-lg leading-relaxed mb-8">
                &ldquo;{testimonial.quote}&rdquo;
              </p>
              
              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#00FFD1]/20 flex items-center justify-center">
                  <span className="text-[#00FFD1] font-bold text-lg">
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <p className="text-white font-medium">{testimonial.name}</p>
                  <p className="text-white/50 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
